module.exports = __webpack_public_path__ + "14d173d1d314908e135b38ca023fb9b0.svg";